var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSntSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5B6DEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.727 11.4767C9.13884 11.4032 9.55658 11.3672 9.975 11.3694V11.3701C10.8188 11.3701 11.4401 11.451 12.0615 11.5319C12.6829 11.6128 13.3043 11.6937 14.148 11.6937C16.4333 11.6937 18 10.7662 18 8.84647C18 6.92745 16.695 6 14.79 6C11.679 6 9.066 8.36038 8.727 11.4767ZM6 15.3535C6 13.4345 7.56675 12.5063 9.852 12.5063C10.6953 12.5063 11.3166 12.5874 11.938 12.6684C12.5595 12.7495 13.1812 12.8306 14.025 12.8306C14.4434 12.8327 14.8612 12.7968 15.273 12.7233C14.934 15.8404 12.321 18.2 9.21 18.2C7.305 18.2 6 17.2725 6 15.3535Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSntSmall);
export default __webpack_public_path__ + "static/media/SntSmall.1ff27824753f2d76141b91fdabd0678b.svg";
export { ForwardRef as ReactComponent };